import React, { useState } from 'react';
import '../CSS/style/style.css';

const RoomCarousel = ({ images, idPrefix }) => {
    const [current, setCurrent] = useState(0);
    // 아직 업로드되지 않은(또는 재생 실패한) 영상은 슬라이드에서 자동 제외
    const [failedVideos, setFailedVideos] = useState([]);

    const slides = (images || []).filter(
        im => !(im.type === 'video' && failedVideos.includes(im.src))
    );

    if (slides.length === 0) return null;

    const index = Math.min(current, slides.length - 1);
    const prev = () => setCurrent(() => (index - 1 + slides.length) % slides.length);
    const next = () => setCurrent(() => (index + 1) % slides.length);

    return (
        <div className="room-carousel">
            <div className="room-carousel-track">
                {slides[index].type === 'video' ? (
                    <video
                        className="room-carousel-media"
                        src={`resource/video/${slides[index].src}`}
                        autoPlay muted loop playsInline
                        onError={() => setFailedVideos(v => [...v, slides[index].src])}
                    />
                ) : (
                    <img
                        src={`resource/img/${slides[index].title}/${slides[index].img}`}
                        className="room-carousel-media"
                        alt={`${slides[index].title}_${slides[index].seq}`}
                    />
                )}

                <span className="room-carousel-counter">{index + 1} / {slides.length}</span>

                <button className="room-carousel-btn room-carousel-btn--prev" onClick={prev} aria-label="이전">&#8249;</button>
                <button className="room-carousel-btn room-carousel-btn--next" onClick={next} aria-label="다음">&#8250;</button>
            </div>

            <div className="room-carousel-dots">
                {slides.map((_, idx) => (
                    <button
                        key={idx}
                        className={`room-carousel-dot${idx === index ? ' active' : ''}`}
                        onClick={() => setCurrent(idx)}
                        aria-label={`${idx + 1}번 슬라이드`}
                    />
                ))}
            </div>
        </div>
    );
};

export default RoomCarousel;
